// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1LinkedWorkItemResourceSchema } from './v1/linkedWorkItemResourceSchema';
import { v1LinkedWorkItemsUpdateSchema } from './v1/linkedWorkItems/updateSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateLinkedWorkItemPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Linked work item ID"),
});

export const updateLinkedWorkItemHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Linked work item updated successfully
 */
export const updateLinkedWorkItem200Schema = z.lazy(() => v1LinkedWorkItemResourceSchema);

/**
 * @description Unauthorized
 */
export const updateLinkedWorkItem401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Linked work item not found
 */
export const updateLinkedWorkItem404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation failed - blank title
 */
export const updateLinkedWorkItem422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateLinkedWorkItemMutationRequestSchema = z.lazy(() => v1LinkedWorkItemsUpdateSchema);

export const updateLinkedWorkItemMutationResponseSchema = z.lazy(() => updateLinkedWorkItem200Schema);
